import { searchListings as searchListingsProvider } from '../../../providers/listings'
import seek from '@adc/seek'

const isTermInQuotes = (term: string) =>
  (term.startsWith('"') && term.endsWith('"')) ||
  (term.startsWith("'") && term.endsWith("'"))

// grab type from seek.fields() method
type FieldConfig = Parameters<seek['fields']>[1]

export const ListingSearchFieldFragment = `
fragment ListingSearchFields on Listing {
  listing_id
  primary_property {
    summary {
      total_bedrooms
      total_bathrooms
      square_footage
      lot_size
      structure_type_code
      structure_type_group
      year_built
    }
}
  formatted_address(format: DOUBLE_LINE)
  event {
    event_type
  }
  listing_status
  listing_status_group
  listing_status_label
  listing_configuration {
    product_type
  }
  primary_photo
  listing_page_path
}`

const fieldsConfig: FieldConfig = {
  fragmentDefinitions: {
    ListingSearchFields: {
      fragment: ListingSearchFieldFragment,
    },
  },
}

export const searchListings = async (searchTerm: string) => {
  let dsl = {}
  if (isTermInQuotes(searchTerm)) {
    dsl = {
      equals: {
        fields: ['listing_id.keyword'],
        values: [searchTerm.slice(1, -1)],
      },
    }
  } else {
    dsl = {
      or: {
        expressions: [
          {
            equals: {
              fields: ['listing_id.keyword'],
              values: [searchTerm],
            },
          },
          {
            query_string: {
              fields: [
                'seller_property.street_description',
                'seller_property.municipality',
                'seller_property.country_primary_subdivision',
                'seller_property.postal_code',
                'properties.summary.address.country_secondary_subdivision',
              ],
              value: `*${searchTerm}*`,
              default_operator: 'AND',
            },
          },
        ],
      },
    }
  }

  return searchListingsProvider({
    dsl,
    fields: ['fragment:ListingSearchFields'],
    fieldsConfig,
  })
}
